import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import JmpModal from './modals/customModal';
import {
  Card, CardBody, Row, Col, Badge
} from 'reactstrap';

import { DragSource } from 'react-dnd'
import CancelJump from './modals/cancelJump'
import EditableJumper from './modals/editableJumper'
import CreatableJumper from './modals/creatableJumper'
// import GooglePicker from 'react-google-picker';
import loadsStore from '../../stores/loads-store'
import RemovableJumper from './modals/removableJumper'
import returnLoadSettings from '../helpers/returnLoadSettings';

const Types = {
  ITEM: 'JUMP'
};

const itemSource = {
  beginDrag(props) {
    //console.log('dragging');
    const item = props
    return item
  },
  endDrag(props, monitor, component) {
    //console.log('endrag')
    if (!monitor.didDrop()) {
      return;
    }
    //return props.handleJumperDrop(props)
    return props;
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}


class RenderPilotCard extends Component {

  constructor() {
    super();
    this.state = {
      optionMenu: false,
      showUpdate: false,
      uploadVideo: false,
      oToken: "",
      albumId: "",
      media: [],
      videosUploaded: false,
    }
  }


  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }
  setUploadVideo = (d) => {
    this.setState({
      uploadVideo: d
    })
  }

  addOverweight = (loadNum, jumpId, val) => {
    var jumpPostBody = { isOverweight: true };
    loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody)
      .then(ret => {
        this.setState({
          optionMenu: false
        });
      })
  }

  addVideoPackage = (loadNum, jumpId, videoPackageId) => {
    var jumpPostBody = { videoPackageId: videoPackageId };
    loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody)
      .then(ret => {
        this.setState({
          optionMenu: false
        });
      })
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        optionMenu: false
      });
    }
  }

  checkForNegatives = (price, videoPrice) => {
    //console.log('check for negatives: ' + price);
    if (price != undefined) {

      if (videoPrice !== undefined) {
        price += videoPrice;
      }

      let priceCell = (price < 0) ?
        {
          value: `($${Math.abs(price).toFixed(2)})`
        }
        :
        {
          value: `$${price.toFixed(2)}`
        }

      if (price < 0) {
        return <Badge style={{ color: 'red' }}> {priceCell.value}</Badge>;
      }

      return <Badge>{priceCell.value}</Badge>;
    }
    else {
      return '';
    }
  }

  toggleOptions = () => {
    this.setState({
      optionMenu: !this.state.optionMenu
    })
  }

  renderPilotLabel = (tandemJump) => {
    if (tandemJump.isCombo) {
      return tandemJump.tandemPackageName;
    }
    else if (tandemJump.videoType !== 'none') {
      return "Tandem w/ " + tandemJump.videoPackageName;
    }
    else {
      return "Tandem"
    }
  }

  // handleBlur = () => {
  //   if(this.state.optionMenu)
  //   {
  //     this.setState({
  //       optionMenu:false
  //     })
  //   }
  // }

  handleUpdate = (type, jumpid) => {
    console.log("🚀 ~ file: RenderPilotCard.js ~ line 160 ~ RenderPilotCard ~ jumpid", jumpid, type + jumpid)
    // this.setState({
    //   showUpdate:true
    // },()=>{
    //   alert(this.state.showUpdate);
    // })
    if (jumpid) {
      document.getElementById(type + jumpid).click();
    }
  }

  handleDelete = (jumpId) => {
    document.getElementById(jumpId).click();
  }


  render() {
    const { pilot, pilotPay, loadNum, jumpId, pilotOptions, isDragging, connectDragSource, price, isCompleted, loadId, loadsToShow, columnsPerGroup, fontSize } = this.props;

    var IsEventEnable = this.props.isCompleted ? 'none' : '';
    const { settingsMoreThan4 } = returnLoadSettings(loadsToShow, columnsPerGroup, fontSize)
    const hasObserevers = pilot.observers.length > 0 ? true : false;
    return connectDragSource(
      <div>
        {
          this.state.optionMenu &&
          <ul className="menu-option">
            <li>
              <span onClick={() => this.handleUpdate("update-Amount", jumpId)}>Add Observer</span>
            </li>
          </ul>
        }
        <Card className="jumpcard" onClick={this.handleBlur}>
          <CardBody style={{ padding: '0px !important' }}>
            <div className={"row"}>
              {/* <Col xs="3" md="12" lg="3" className="jumptype" style={{padding: '0 0 0 9px' }}>
                {this.renderTandemLabel(tandemJump)}
                {price !== undefined ? this.checkForNegatives(price, videoPrice) : ''}
              </Col> */}
              <div className={settingsMoreThan4 ? 'funjumptype custom-col' : 'funjumptype col-3'}
                style={{ backgroundColor: '#6ca1c9', display: 'flex', justifyContent: 'center', alignItems: 'center',fontSize:'1.20em'}}>
                Pilot
              </div>
              <div className={settingsMoreThan4 ? "cardmiddle jumpers-container" : "cardmiddle col-9"} style={{ margin: 'auto' }}>
                <ul className="tandem-load" style={{ backgroundColor: 'white' }}>
                  <li style={hasObserevers ? {} : {width: '95.5%'}} >
                    <EditableJumper
                      type={"pilot"}
                      label={"P"}
                      isToday={this.props.isToday}
                      loadNum={loadNum}
                      jumpId={jumpId}
                      jumper={pilot}
                      isCompleted={this.props.isCompleted}
                      loadId={this.props.loadId}
                      options={pilotOptions}
                      price={pilotPay}
                      hasObserevers={hasObserevers}
                      columnsPerGroup={this.props.columnsPerGroup}
                      loadsToShow={this.props.loadsToShow}
                    />
                  </li>
                  {
                    pilot.observers.map(observer => {
                      return (
                        <li>
                          <RemovableJumper
                            isToday={this.props.isToday}
                            loadNum={loadNum}
                            jumper={observer}
                            loadId={loadId}
                            isCompleted={isCompleted}
                            type="observer"
                          />
                        </li>
                      )
                    })
                  }

                </ul>
                {loadsStore.displayOnly ? null:
                  <div className="right-menu" onClick={this.toggleOptions}>
                    <span style={{backgroundColor:"white"}}>
                      <i className="fa fa-ellipsis-v"></i>
                    </span>
                  </div>
                }


              </div>
              {/* <Col xs="1" md="2" lg="1" className="jumpClose" style={{ paddingLeft: '4px' }}>
                <UpdateAmount isToday={this.props.isToday} loadNum={loadNum} jumpId={jumpId} loadNum={loadNum} jumpType={"tandemJump"}
                  isCompleted={this.props.isCompleted} loadId={this.props.loadId} jumpData={tandemJump} isUltra= {tandemJump.isUltra} />
                {!this.props.isCompleted && <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"tandemJump"} />}
              </Col> */}
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

export default DragSource(Types.ITEM, itemSource, collect)(RenderPilotCard)
